import { useState, useContext, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { Nav, Navbar } from 'react-bootstrap';
import "../../css/common.module.css";
import "../../css/Header.css";
import Logo from '../../images/IDSLogo.png';
import KeyHandler from "../../components/KeyHandler";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../../utils/FetchUtil";
import { emptyCache } from "../../utils/helper.js";

function AnalyticsHeader() {
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const [isScrolled, setIsScrolled] = useState(false);
	FetchUtil.setUserLanguage(i18n, userCtx);
	const [uniqueAnalyticsAccess, setUniqueAnalyticsAccess] = useState([]);
	
	const handleScroll = () => {
		const offset = window.scrollY;
		if (offset > 250) {
			setIsScrolled(true);
		} else {
			setIsScrolled(false);
		}
	}
	useEffect(() => {
		let  analyticsAccess = [];
		if (!userCtx.isAuthenticated) {
			navigate("/");
		}
		if(userCtx.analyticsAccess && (userCtx.analyticsAccess instanceof Array) && userCtx.analyticsAccess.length > 0){
			userCtx.analyticsAccess.map((analyticsAccessObj) => {
				if(analyticsAccess.length == 0){
					analyticsAccess.push(analyticsAccessObj.analyticsName);
				} else {
					if(!analyticsAccess.includes(analyticsAccessObj.analyticsName)){
						analyticsAccess.push(analyticsAccessObj.analyticsName);
					}
				}
			});
			setUniqueAnalyticsAccess(analyticsAccess);
		} 
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleLogOffClick = event => {
		invokeLogOff();
	};

	function invokeLogOff() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ "source": "web" }),
		};

		try {
			FetchUtil.fetchAPI("Logoff", "/Service/UserService/Logoff", requestOptions, logoffSuccess, logoffFail);
		} catch (error) {
			setError(error.message);
			navigate("/", {
				state: {
					errorMessage: t("error.error") + " " + error.message,
				},
			});
		}
	}
	function openLogoff() {
		let logoutWindow = window.open("https://idecisionsciences.awsapps.com/start#/signout", "Application Logout", "width=100,height=100");
		if (logoutWindow) {
			let timeoutVar = setTimeout(
				function() {
					logoutWindow.close();
				}
					.bind(this),
				5000
			);
		}
	}

	function resetContext() {
		userCtx.addUserName("");
		userCtx.addLoggedInUserId("");
		userCtx.addRole("");
		userCtx.addIsAuthenticated(false);
		userCtx.clearStorage();
		userCtx.addEnabledMFA(0);
		userCtx.addAnalyticsAccess([]);
		userCtx.addUserCompanyId(0);
		userCtx.addUserType("");
		userCtx.addCompanyType("");
		userCtx.addHasDeleteAccess(false);
	}
	function logoffFail(redirect) {
		openLogoff();
		emptyCache();
		resetContext();
		navigate("/", {
			state: {
				errorMessage: "Logout failed.",
			},
		});
	}

	function logoffSuccess(responseData) {
		openLogoff();
		emptyCache();
		resetContext();
		let logOffResponse;
		if (responseData) {
			logOffResponse = responseData.logOffResponse;
			if (logOffResponse && logOffResponse.errorCode === "0") {

				navigate("/", {
					state: {
						errorMessage: "",
					},
				});
			} else if (logOffResponse && logOffResponse.errorCode === "114"){
				setError(t("error.error") + " " + logOffResponse.errorMessage);
				navigate("/",{
			        state: {
			            	errorMessage: t("error.sessionTimeout"),
			        	},
			     });
			} else if (logOffResponse) {
				setError(t("error.error") + " " + logOffResponse.errorMessage);
				navigate("/", {
					state: {
						errorMessage: t("error.error") + " " + logOffResponse.errorMessage,
					},
				});
			} else {
				navigate("/", {
					state: {
						errorMessage: t("error.error"),
					},
				});
			}
		} else {
			setError(t("error.error"));
			navigate("/", {
				state: {
					errorMessage: t("error.error"),
				},
			});
		}
	}
	return (
		<>
			<Navbar bg="dark" variant="light"
				expand="lg"
				className={isScrolled ? " scrolled mybgcolor " : " mybgcolor "}
			>
				<Navbar.Brand className="nav-item text-light px-2"><img alt="" src={Logo} className="d-inline-block align-top logo" />{' '}</Navbar.Brand>
				<div className="px-4"></div>

				<Navbar.Toggle aria-controls="basic-navbar-menu" />
				<Navbar.Collapse id="basic-navbar-menu" className="navbar-menu">
					<Nav className="ml-auto">
						<NavLink to="/pages/landing" className=" nav-link text-light navlink-bg"><span className="fa fa-home"> </span>
							{t("header.home")}
						</NavLink>
					</Nav>
					{(uniqueAnalyticsAccess.length > 0)? (uniqueAnalyticsAccess.map((analyticsAccessObj) => (
						<Nav className="ml-auto">
							<NavLink to="/pages/analytics" state={{analyticsName : analyticsAccessObj}}
								className=" nav-link text-light navlink-bg">
								{analyticsAccessObj}
							</NavLink>
						</Nav>
					))):(<></>)}
				</Navbar.Collapse>
				<Navbar.Collapse className="navbar-logoff">
					<Nav className="ml-auto">
						<NavLink className=" nav-link text-light navlink-bg" onClick={handleLogOffClick}><span className="fa fa-sign-out"> </span>
							{t("header.logoff")}
						</NavLink>
					</Nav>
				</Navbar.Collapse>
				<KeyHandler />
			</Navbar>
			<div className={isScrolled ? " navbar-banner navbar-light bg-success scrolled-banner" : " navbar-banner navbar-light bg-success"}>
				<Navbar.Brand className="nav-item text-light px-8 fw-semibold">{t("header.hello")} {userCtx.userName}</Navbar.Brand>
			</div>
		</>
	);
}

export default AnalyticsHeader;
